import { render } from "./Dashboard.vue?vue&type=template&id=542c15ce"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.css?vue&type=style&index=0&lang=css&external"
import "@/components/ui/styles/DashboardSidebar.css?vue&type=style&index=1&lang=css&external"
import "./Dashboard.vue?vue&type=style&index=2&id=542c15ce&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__